// Фронтовая копия таблицы переходов state-machine'а заказа
// (источник истины: backend/app/orders/state_machine.py ALLOWED_TRANSITIONS,
// architecture.md §5.5). Если бэк когда-нибудь начнёт отдавать allowed_next
// в Order — переключимся, а до тех пор показываем кнопки сами.
//
// Жизненный цикл:
//   accepted     → in_progress | ready | cancelled
//   in_progress  → ready | cancelled
//   ready        → issued | cancelled
//   issued       → ∅ (терминальный)
//   cancelled    → ∅ (терминальный)
//
// Внимание: ТЗ M2.6 указывает на чуть отличающуюся таблицу (`accepted → ready`,
// `ready → in_progress`), но это исторический мисматч из старого ТЗ.
// Источник истины здесь — backend/app/orders/state_machine.py
// (см. tests/orders/test_state_machine.py): эта таблица согласована с ним.

import type { components } from '@/api/types.gen';

export type OrderStatus = components['schemas']['OrderStatus'];

export const ALLOWED_TRANSITIONS: Readonly<Record<OrderStatus, ReadonlyArray<OrderStatus>>> = {
  accepted: ['in_progress', 'ready', 'cancelled'],
  in_progress: ['ready', 'cancelled'],
  ready: ['issued', 'cancelled'],
  issued: [],
  cancelled: [],
};

export function nextStatuses(current: OrderStatus): ReadonlyArray<OrderStatus> {
  return ALLOWED_TRANSITIONS[current] ?? [];
}

export function isTerminal(status: OrderStatus): boolean {
  return ALLOWED_TRANSITIONS[status].length === 0;
}

export function canTransition(from: OrderStatus, to: OrderStatus): boolean {
  return ALLOWED_TRANSITIONS[from].includes(to);
}

// Линейный «основной» поток для отрисовки Timeline (Steps). Cancelled — вне
// линейки, рендерится отдельно как «Отменён».
export const TIMELINE_FLOW: ReadonlyArray<OrderStatus> = [
  'accepted',
  'in_progress',
  'ready',
  'issued',
];
